import { render, staticRenderFns } from "./LatestDigitalSignContractsWidget.vue?vue&type=template&id=a2b63d88&scoped=true"
import script from "./LatestDigitalSignContractsWidget.vue?vue&type=script&lang=js"
export * from "./LatestDigitalSignContractsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b63d88",
  null
  
)

export default component.exports